module.exports = __webpack_public_path__ + "static/media/IconDr.6a8cce3f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/icons/IconDr.svg
// module id = 939
// module chunks = 0